import { render, staticRenderFns } from "./OptinOnboarding.vue?vue&type=template&id=953aa482&scoped=true&"
import script from "./OptinOnboarding.vue?vue&type=script&lang=js&"
export * from "./OptinOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953aa482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953aa482')) {
      api.createRecord('953aa482', component.options)
    } else {
      api.reload('953aa482', component.options)
    }
    module.hot.accept("./OptinOnboarding.vue?vue&type=template&id=953aa482&scoped=true&", function () {
      api.rerender('953aa482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/OptinOnboarding.vue"
export default component.exports